/* unplugin-vue-components disabled */import script from "./CourseItem.vue?vue&type=script&setup=true&name=PracticeItem&lang=js"
export * from "./CourseItem.vue?vue&type=script&setup=true&name=PracticeItem&lang=js"

import "./CourseItem.vue?vue&type=style&index=0&id=20d76e80&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20d76e80"]])

export default __exports__